import classNames from "classnames";
import { icons } from "./icons";

type IconName = keyof typeof icons;

interface IconButtonProps {
  icon: IconName;
  isDisabled?: boolean;
  isTertiary?: boolean;
  className?: string;
  onClick?: () => void;
}

export function IconButton({ icon, className, isDisabled, isTertiary, onClick }: IconButtonProps) {
  return (
    <button
      onClick={onClick}
      className={classNames(
        `m-0 flex size-7 cursor-pointer touch-none select-none items-center justify-center rounded-full p-0 outline-none transition-all disabled:cursor-auto ${className}`,
        {
          "border-none border-transparent bg-primary-100": !isTertiary && !isDisabled,
          "border-none border-transparent bg-primary-100/80": !isTertiary && isDisabled,
          "border border-primary-100 bg-transparent": isTertiary && !isDisabled,
          "border border-primary-100/80 bg-transparent": isTertiary && isDisabled,
        },
      )}
      disabled={isDisabled}
      aria-label={icon}
    >
      <svg
        className={classNames("size-full rounded-full", {
          "fill-background-100": !isTertiary && !isDisabled,
          "fill-background-100/80": !isTertiary && isDisabled,
          "fill-primary-100": isTertiary && !isDisabled,
          "fill-primary-100/80": isTertiary && isDisabled,
        })}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {icons[icon]}
      </svg>
    </button>
  );
}
